import React from 'react';

import { css, cx } from '@emotion/css';
import { Theme, Typography } from '@mui/material';

import { FontSizes } from '@/assets/fonts';
import { IconType } from '@/assets/icons';
import { Button, ButtonProps } from '@/components/button/Button';
import { useStyles } from '@/hooks/useStyles';

type IconPlacement = 'left' | 'right';
export type IconButtonProps = ButtonProps & {
  icon: IconType;
  placement: IconPlacement;
  iconClassname?: string;
};

/**
 * @deprecated use MUI Button instead
 */
export const IconButton: React.FC<IconButtonProps> = ({
  icon: Icon,
  buttonType,
  textType = 'button',
  placement,
  iconClassname,
  children,
  className,
  ...props
}) => {
  const styles = useStyles(makeStyles);

  return (
    <Button
      buttonType={buttonType}
      className={cx(styles.button, className)}
      {...props}
    >
      <>
        {placement === 'left' ? (
          <Icon
            className={cx(
              styles.icon,
              {
                [styles.iconLeft]: children !== undefined && children !== null,
              },
              iconClassname,
            )}
          />
        ) : null}
        {typeof children === 'string' ? (
          <Typography variant={textType} className={styles.text}>
            {children}
          </Typography>
        ) : (
          children
        )}
        {placement === 'right' ? (
          <Icon className={cx(styles.icon, styles.iconRight, iconClassname)} />
        ) : null}
      </>
    </Button>
  );
};

const makeStyles = (theme: Theme) => ({
  button: css`
    overflow: clip;
  `,
  text: css`
    color: inherit;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: clip;
    min-width: 0;
    width: 100%;
  `,
  icon: css`
    width: ${FontSizes.body};
    height: ${FontSizes.body};
  `,
  iconLeft: css`
    margin-right: ${theme.spacing(8)};
  `,
  iconRight: css`
    margin-left: ${theme.spacing(8)};
  `,
  plain: css``,
});
